export const quickNavItems = [
  { en: "MEDICAL HAIR REMOVAL", jp: "医療脱毛", no: "01", href: "/treatment/hair-removal" },
  { en: "MEDICAL SLIM ZERO", jp: "医療痩身", no: "02", href: "/treatment/slim-zero" },
  { en: "SKIN MANAGEMENT", jp: "お肌管理", no: "03", href: "/treatment/skin-management" },
  { en: "REGENERATIVE MEDICINE", jp: "再生医療", no: "04", href: "/treatment/regenerative" },
  { en: "INJECTABLES", jp: "注入治療", no: "05", href: "/treatment/injectables" },
  { en: "EYE TREATMENT", jp: "二重・目元", no: "06", href: "/treatment/eye" },
];

export const mainTreatments = [
  {
    id: "hair-removal",
    href: "/treatment/hair-removal",
    en: "MEDICAL HAIR REMOVAL",
    jp: "医療脱毛",
    copy: "自己処理の負担を減らし、\nもっと自信を持てる素肌へ。",
    description: "一人ひとりの毛質や肌状態に合わせて、医療レーザー脱毛をご提案します。",
    items: ["レディース", "メンズ", "全身", "顔", "VIO", "ヒゲ", "部位別"],
    cta: "医療脱毛を見る",
    tone: "warm",
    image:
      "/images/site/sbdc-top-medical-hair-removal-v1.webp",
    imageAlt: "渋谷美容皮膚科クリニックの医療脱毛",
  },
  {
    id: "slim-zero",
    href: "/treatment/slim-zero",
    en: "MEDICAL SLIM ZERO",
    jp: "医療痩身・ダイエット",
    copy: "落としにくい脂肪に、\n医療の力でアプローチ。",
    description: "部分痩せから全身のボディメイクまで、目的に合わせて組み合わせてご提案します。",
    items: ["新脂肪溶解注射", "RF（ラジオ波）", "脂肪冷却", "医療用EMS"],
    cta: "Medical Slim ZEROを見る",
    tone: "greige",
    image:
      "/images/site/sbdc-top-medical-slim-zero-v1.webp",
    imageAlt: "渋谷美容皮膚科クリニックの医療痩身 Medical Slim ZERO",
  },
  {
    id: "skin-management",
    href: "/treatment/skin-management",
    en: "SKIN MANAGEMENT",
    jp: "お肌管理",
    copy: "今の肌だけではなく、\nこれからの肌まで考える。",
    description: "肌状態を丁寧に確認し、今必要なケアと将来のためのケアを組み合わせてご提案します。",
    items: ["ニキビ", "シミ", "毛穴", "たるみ・シワ", "肌質改善"],
    cta: "お肌管理を見る",
    tone: "ivory",
    image:
      "/images/site/sbdc-top-skin-management-v1.webp",
    imageAlt: "渋谷美容皮膚科クリニックのお肌管理",
  },
];

export const specialTreatments = [
  {
    id: "regenerative",
    href: "/treatment/regenerative",
    en: "REGENERATIVE MEDICINE",
    jp: "再生医療",
    lines: ["StemSup点滴", "幹細胞培養上清液を用いた点滴メニュー"],
    cta: "再生医療を見る",
  },
  {
    id: "injectables",
    href: "/treatment/injectables",
    en: "INJECTABLES",
    jp: "注入治療",
    lines: ["ボトックス", "ヒアルロン酸"],
    cta: "注入治療を見る",
  },
  {
    id: "eye",
    href: "/treatment/eye",
    en: "EYE TREATMENT",
    jp: "二重・目元",
    lines: ["二重埋没"],
    cta: "二重・目元を見る",
  },
];

export const pickUpItems = [
  {
    id: "pickup-1",
    href: "/treatment/slim-zero",
    label: "PICK UP 01",
    en: "MEDICAL SLIM ZERO",
    jp: "医療痩身・ダイエット",
    text: "落としにくい脂肪に、医療の力でアプローチ。ライフスタイルに合わせてご提案します。",
    tag: "NEW",
    image:
      "/images/site/sbdc-top-pickup-medical-slim-zero-v1.webp",
    imageAlt: "渋谷美容皮膚科クリニックの医療痩身 Medical Slim ZERO",
    objectPosition: "object-center",
  },
  {
    id: "pickup-2",
    href: "/treatment/regenerative",
    label: "PICK UP 02",
    en: "STEMSUP IV THERAPY",
    jp: "再生医療",
    text: "幹細胞培養上清液 StemSupを点滴で投与するメニューをご案内します。",
    tag: "FEATURED",
    image:
      "/images/site/sbdc-top-pickup-stemsup-v1.webp",
    imageAlt: "渋谷美容皮膚科クリニックのStemSup点滴",
    objectPosition: "object-center",
  },
  {
    id: "pickup-3",
    href: "/treatment/hair-removal",
    label: "PICK UP 03",
    en: "MEDICAL HAIR REMOVAL",
    jp: "医療脱毛",
    text: "自己処理の負担を減らし、もっと自信を持てる素肌へ。",
    tag: "POPULAR",
    image:
      "/images/site/sbdc-top-pickup-hair-removal-v1.webp",
    imageAlt: "渋谷美容皮膚科クリニックの医療脱毛",
    objectPosition: "object-center",
  },
];